import {API_URL} from "../config";

export const REGISTER_URL = `${API_URL}/users`;

export const REGISTER_TURBO_URL = `https://api.tizeti.com/api/v1/users/turbo`;
